import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
const SecteurContext = createContext();

export const SecteurProvider = ({ children }) => {
    // const [secteurs, setsecteurs] = useState([]);
    // You can have a single state object for user attributes
    const [secteurs, setSecteurs] = useState({});
    
  
  
  
    const setSecteurAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setSecteurs((prevSecteur) => ({ ...prevSecteur, ...attributes }));
     

    };

  
    return (
      <SecteurContext.Provider value={{ secteurs,  setSecteurAttributes }}>
        {children}
      </SecteurContext.Provider>
    );
  };
  SecteurProvider.propTypes={
    children: PropTypes.node.isRequired
  }
  
  export const useSecteur = () => {
    return useContext(SecteurContext);
  };